import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AddEditUserService } from '../../services/add-edit-user.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
//import { LocalApiConnectorService } from '../../services/local-api-connector.service';
import { AuthGuard } from '../../services/auth-guard.service';
import { DataTransferService } from '../../services/DataTransferService';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { ConfigService } from '../../services/endpoint.config.service';
declare var $: any;

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  ss: any;

  defaultSettings: any;
  reports: any;
  printingSettings: any;
  locationSettings: any[] = JSON.parse(sessionStorage.getItem('branchSettings')) 
  @Output() cashierSettings = new EventEmitter();
  constructor(private user: AddEditUserService,
    private dts: DataTransferService,
   // private agent: LocalApiConnectorService,
    private loader: NgxUiLoaderService,
    private toaster: ToastrService, private router: Router, private configs: ConfigService) {
    this.printingSettings = {
      ReceiptLabelType: {
        reportTypeId: 2,
        compies: 1,
        printer: 0
      },
      SecondLabelType: {
        reportTypeId: 1,
        compies: 1,
        printer: 0
      },
      Waybillform: {
        reportTypeId: 1,
        compies: 1,
        printer: 0
      },
      TaxReceiptLabelType: {
        reportTypeId: 3,
        compies: 1,
        printer: 0
      },
      CashierOutReport: {
        reportTypeId: 4,
        compies: 1,
        printer: 0
      }
    }
  }
  toArray(obj) {
    var arr = [];
    for (var x in obj) if (obj.hasOwnProperty(x)) {
      arr.push(obj[x]);
    }
    return arr;
  }
  printers = [] as any[];
  allowPrintingMultipleLabels = false;
  ngOnInit() {

    this.ss = $("#dvamxprint").amxPrintMngr('992ada1b68b34b618173a221393ba8ce',this.configs.getEnviromentId());
    this.ss.start();

   this.ss.result = function (e) {
		  var y = e;
	  };

     setTimeout(() => {
       this.ss.config();
      }, 2000)


    let setting = this.locationSettings.find(m => m.Key == 31)
    if (setting != undefined)
      this.allowPrintingMultipleLabels = setting.Value == 'True'

    // this.dts.getPrinters().subscribe(x => {
    //       this.printers = x;
    // });

    this.getUserSettings();
    this.getReports();
    this.getPrintingSettings();
  }
  //print() {
  //  this.agent.print((res) => { console.log(res) },, { "PrinterName": this.printingSettings.ReceiptLabelType.printer})
  //}

  getUserSettings() {
    this.defaultSettings = JSON.parse(sessionStorage.getItem('user')).Settings;
  }

  getReports() {

    this.user.getReports((res) => {
      var resp = res as any[];
      this.reports = {
        labelReport: resp.filter(x => x.reportTypeId == 1)[0],
        receiptReport: resp.filter(x => x.reportTypeId == 2)[0],
        taxInvoicesReport: resp.filter(x => x.reportTypeId == 3)[0],
        cashoutsReport: resp.filter(x => x.reportTypeId == 4)[0]
      }
    }, (err) => { })
  }

  emitSetttings() {
    this.cashierSettings.emit(this.defaultSettings)
  }

  getPrintingSettings() {
    var printingSettings = JSON.parse(localStorage.getItem("printingSettings"));
    if (printingSettings != undefined && printingSettings != null)
      this.printingSettings = printingSettings;
  }

  saveUserPrintingSettings() {
    var printingSettings = JSON.parse(localStorage.getItem("printingSettings"));
    if (((printingSettings == null || printingSettings == undefined) && this.checkPrintersSettings()) || ((printingSettings != null || printingSettings != undefined) && this.checkPrintersSettings())) {
      localStorage.setItem("printingSettings", JSON.stringify(this.printingSettings));
      this.toaster.success("Settings updated successfully!");
      setTimeout((x) => {
        this.router.navigate(['/dashboard']);
      }, 700)
    }
    else {
      this.toaster.warning("Please enter all reports printers settings!");
    }
  }

  checkPrintersSettings() {
    var ReceiptLabelTypePrinter = this.printingSettings.ReceiptLabelType.printer;
    var WaybillFormPrinter = this.printingSettings.Waybillform.printer;
    var TaxReceiptLabelTypePrinter = this.printingSettings.TaxReceiptLabelType.printer;
    var CashierOutReportPrinter = this.printingSettings.CashierOutReport.printer;
    if (ReceiptLabelTypePrinter != 0 && WaybillFormPrinter != 0 && TaxReceiptLabelTypePrinter != 0 && CashierOutReportPrinter != 0) {
      return true;
    }
    else {
      if (ReceiptLabelTypePrinter == 0 || WaybillFormPrinter == 0 || TaxReceiptLabelTypePrinter == 0 || CashierOutReportPrinter == 0) {
        return false;
      }
    }

  }
}

